import { Link as RouterLink } from 'react-router-dom';
import { layoutSizes } from '@/theme/layoutSizes';
import { fontFamilies, motion, r, s, typographyTokens } from '@/theme/tokens';
import { Box, Chip, Text } from '@/ui';
import type { ReactElement } from 'react';

type AppSidebarBrandProps = {
  collapsed?: boolean;
};

const sidebarBrandLogoSize = 32;

export const AppSidebarBrand = ({ collapsed = false }: AppSidebarBrandProps): ReactElement => (
  <Box
    component={RouterLink}
    to="/execution-runs"
    aria-label="FlowQA home"
    sx={(theme) => ({
      '--sidebar-brand-height': `calc(${layoutSizes.topBar.height}px + (${s('xs')} * 2) + 1px)`,
      color: theme.app.colors.text,
      textDecoration: 'none',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: collapsed ? 'center' : 'flex-start',
      gap: s('sm'),
      minHeight: 'var(--sidebar-brand-height)',
      height: 'var(--sidebar-brand-height)',
      pl: collapsed ? s('md') : s('lg'),
      pr: collapsed ? s('xs') : s('lg'),
      width: '100%',
      boxSizing: 'border-box',
      overflow: 'hidden',
      transition: 'padding 180ms ease',
    })}
  >
    <Box
      component="img"
      src="/logo.png"
      alt=""
      sx={{
        height: `${sidebarBrandLogoSize}px`,
        width: `${sidebarBrandLogoSize}px`,
        display: 'block',
      }}
    />
    {collapsed ? null : (
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: s('lg'),
          minWidth: 0,
          overflow: 'hidden',
          opacity: 1,
          transform: 'translateX(0)',
          transition: `opacity ${motion.durations.fast} ${motion.easing.standard}, transform ${motion.durations.medium} ${motion.easing.standard}`,
        }}
      >
        <Text
          role="sectionTitle"
          component="span"
          sx={{
            fontFamily: fontFamilies.body,
            fontSize: 21,
            lineHeight: 1,
            fontWeight: typographyTokens.bodyStrong.fontWeight,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
          }}
        >
          FlowQA
        </Text>
        <Chip
          label="Beta"
          tone="red"
          size="xs"
          transform="uppercase"
          sx={{ borderRadius: r('sm') }}
        />
      </Box>
    )}
  </Box>
);
